import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=6a4e2074&scoped=true&"
import script from "./InventorySummary.vue?vue&type=script&lang=js&"
export * from "./InventorySummary.vue?vue&type=script&lang=js&"
import style0 from "./InventorySummary.vue?vue&type=style&index=0&id=6a4e2074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e2074",
  null
  
)

export default component.exports